import { AccountDetails } from "./AccountDetails";
import { Appearance } from "./Appearance";
import { ExtremeMeasures } from "./ExtremeMeasures";
import { ResetPassword } from "./ResetPassword";

export function MyProfile() {

    const children = {
        accountDetails: AccountDetails(),
        resetPassword: ResetPassword(),
        appearance: Appearance(),
        extremeMeasures: ExtremeMeasures()
    }

    function render() {
        return /*html*/`
        <div id="vertical-tab-myaccount-profile" role="tabpanel" aria-labelledby="vertical-tab-myaccount-profile">
    <!-- Account Card -->
    <div
        class="md:min-h-[calc(100vh-90px)] p-4 md:p-5 bg-white border border-gray-200 shadow-sm rounded-xl dark:bg-neutral-800 dark:border-neutral-700">
        <!-- Title -->
        <div>
            <h2 class="text-lg font-semibold text-gray-800 dark:text-neutral-200">
                My Profile
            </h2>
            <p class="text-sm text-gray-500 dark:text-neutral-500">
                Manage your name, password, and account settings
            </p>
        </div>
        <!-- End Title -->

        <!-- Form -->
            <!-- Personal Info -->
            ${children.accountDetails.render()}
            <!-- End Personal Info -->

            <!-- Password -->
            
            <!-- End Password -->

            <!-- Appearance -->
            ${children.appearance.render()}
            <!-- End Appearance -->

            <!-- Extreme Measures -->
            <div class="py-6 sm:py-8 space-y-5 last:pb-0 border-t border-gray-200 first:border-t-0 dark:border-neutral-700">
                <div class="inline-flex items-center gap-x-2">
                    <h2 class="font-semibold text-gray-800 dark:text-neutral-200">
                    Security
                    </h2>
                </div>
                ${children.resetPassword.render()}
                ${children.extremeMeasures.render()}
            </div>
            <!-- End Extreme Measures -->
        <!-- End Form -->
    </div>
    <!-- End Account Card -->
</div>`;

    }
    return { render, children };
}